module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('svg-circle-sector', {
    staticClass: "countdown-timer",
    attrs: {
      "angle": _vm.angle,
      "text": _vm.text
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "controls-timer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-link",
    class: {
      disabled: _vm.state === 0
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.start
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.playIcon
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    class: {
      disabled: _vm.state === 1 || _vm.state === 2
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.pauseIcon
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-stop",
    class: {
      disabled: _vm.state === 2
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stop
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.stopIcon
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea5b36a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timer/CountDownTimer.vue
// module id = 50
// module chunks = 0